import { DropzoneArea } from "@skrice.studio/material-ui-dropzone-mui";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from "@mui/material";
import axios from "axios";
import { createForm } from "rc-form";
import * as React from "react";
import { Config } from "../../../../config/config";
import { Helpers } from "../../../../utils/helpers";
import { PopupMessage } from "../../../../utils/message";

interface NewFileSate {
    modalVisible: boolean;
    isLoaded: boolean;
    creatingFile: boolean;
    bundles: any[];
    uploadEnabled: boolean;
    files: any[];
}

interface NewFileProps {
    buttonText?: string;
    currentDirectory: string;
    refreshParent(): void;
    form: any;
}

export class NewFileModalFormWrapped extends React.Component<NewFileProps, NewFileSate> {
    form;

    constructor(props) {
        super(props);

        this.state = {
            // Flags
            modalVisible: false,
            isLoaded: false,
            creatingFile: false,
            bundles: [],
            uploadEnabled: true,
            files: [],
        };
    }
    componentDidMount() {
        this.loadEnvironmentObjects();
    }

    /**
     * Callback function for create button
     * Calling this function a modal will be shown
     */
    onModalShow = () => {
        this.setState({
            modalVisible: true,
        });
    }

    onModalClose = () => {
        this.setState({
            modalVisible: false,
            uploadEnabled: true,
        }, () => {
            // Reset form values
            this.props.form.resetFields();
        });
    }

    loadEnvironmentObjects = () => {
        axios.post(`${Config.getInstance.apiUrl}/api/bundle/list`, {
            env: "Local",
        }, {
            headers: {
                Authorization: Helpers.getSessionId(),
            },
        }).then((result) => {
            this.setState({
                isLoaded: true,
                bundles: result.data.data.map((el) => {
                    const o = {...el};
                    o.visible = true;
                    return o;
                }),
            });
       }).catch(error => {
            PopupMessage.error("Something went wrong!", 5, error);

            // If error then reset graph options
            this.setState({
                isLoaded: true,
            });
       });
    }

    handleModalCreate = () => {
        const { form } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            const formData = new FormData();

            formData.append("file", this.state.files[0]);
            formData.append("fileName", values.file_name);
            formData.append("fileNamePlaceholder", values.file_name_placeholder);
            formData.append("currentDir", this.props.currentDirectory);

            this.setState({ creatingFile: true }, () => {
                axios.post(`${Config.getInstance.apiUrl}/api/bundle/upload_game_file`, formData, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                }).then((result) => {
                    // Reset form fields
                    form.resetFields();
                    // Otherwise load and show a list with applications
                    return this.setState({
                        creatingFile: false,
                        modalVisible: false,
                        uploadEnabled: true,
                    }, () => {
                        // Refresh parent component
                        this.props.refreshParent();
                    });
                }).catch((error) => {
                    PopupMessage.error("Something went wrong!", 5, error);

                    this.setState({
                        creatingFile: false,
                    });
                });
            });
        });
    }

    onDropzoneChange = (files) => this.setState({ files });

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <React.Fragment>
                <Button disableElevation onClick={this.onModalShow} color="primary" size="small" variant="contained">
                    {this.props.buttonText}
                </Button>

                <Dialog
                    open={this.state.modalVisible}
                    onClose={this.onModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Upload file</DialogTitle>
                    <DialogContent style={{ overflow: "hidden" }}>
                        <div>
                            <DropzoneArea
                                onChange={this.onDropzoneChange}
                                acceptedFiles={["application/json"]}
                                showFileNamesInPreview={true}
                                filesLimit={1}
                                showFileNames={true}
                            />
                        </div>
                        <div>
                            {getFieldDecorator("file_name",
                                {rules: [{
                                    required: true,
                                    message: "Please enter file name",
                                }]},
                            )(
                                <TextField
                                    label="File name"
                                    helperText="If file is a configuration file then name should contain only ID number, e.g. 2000"
                                    margin="normal"
                                    style={{ width: "100%" }}
                                />,
                            )}

                            {getFieldDecorator("file_name_placeholder",
                                {rules: [{
                                    required: true,
                                    message: "Please enter short comment",
                                }]},
                            )(
                                <TextField
                                    label="File name placeholder"
                                    helperText="Alternative file name which will only appear in this panel. This could help when trying to find a file"
                                    margin="normal"
                                    style={{ width: "100%" }}
                                />,
                            )}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button disableElevation onClick={this.onModalClose} color="primary">
                            Cancel
                        </Button>

                        {this.state.files.length > 0 &&
                            <div className="loading-button-wrapper">
                                <Button disableElevation onClick={this.handleModalCreate} color="primary" disabled={this.state.creatingFile}>
                                    Upload
                                </Button>

                                {this.state.creatingFile && <CircularProgress size={24} className="button-progress"/>}
                            </div>
                        }
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export const NewFileModalForm = createForm()(NewFileModalFormWrapped);
